import React, { Children } from 'react';
import PropTypes from 'prop-types';
import { Dialog } from '@getgo/chameleon-web-react-wrapper';
import classes from './dialog.scss';
import { Box } from '@mui/material';
import { Typography } from '@getgo/chameleon-web-react-wrapper';

const KeyValView = ({
  heading,
  subheading,
  topBottomMargin,
}) => {
  return (
    <Box style={{ margin: topBottomMargin ? '12px 0' : '0', width: "85%" }}>
      <Typography variant="body-medium">{heading}</Typography>
      <Typography variant="caption-medium" color="type-color-secondary">{subheading}</Typography>
    </Box>
  );
};

KeyValView.propTypes = {
  heading: PropTypes.func,
  subheading: PropTypes.element,
  topBottomMargin: PropTypes.bool,
};

export default KeyValView;
